module.exports = __webpack_public_path__ + "static/media/hilda_in_a_kimono_by_corriger-dasn7ky.bc621e05.png";